import { StatCard, StatCardRow } from '@/components/ui/StatCard';

import { State } from '../State';

export function StatCardExamples() {
  return (
    <>
      <State title="Four across, with every kind of change line">
        <StatCardRow
          label="Sample summary, four across"
          testId="gallery-stat-card-four-group"
        >
          <StatCard
            label="Supporters"
            value="4,631"
            change={{ percent: 6.4, direction: 'up' }}
            testId="gallery-stat-card-up-card"
            caption="People following the organization"
          />
          <StatCard
            label="Notifications sent"
            value="12"
            change={{ percent: -3.1, direction: 'down' }}
            testId="gallery-stat-card-down-card"
          />
          <StatCard
            label="Active campaigns"
            value="3"
            change={{ percent: 0, direction: 'flat' }}
            testId="gallery-stat-card-flat-card"
          />
          <StatCard
            label="Surveys open"
            value="1"
            caption="No change line at all"
            testId="gallery-stat-card-no-change-line-card"
          />
        </StatCardRow>
      </State>

      <State title="No previous period" note="A change with nothing to compare against.">
        <StatCardRow
          label="Sample summary, first period"
          testId="gallery-stat-card-first-group"
        >
          <StatCard
            label="Supporters"
            value="4,631"
            change={{ percent: null, direction: 'flat' }}
            testId="gallery-stat-card-no-previous-card"
          />
        </StatCardRow>
      </State>

      <State title="Loading" note="Placeholders the size of what replaces them.">
        <StatCardRow
          label="Sample summary, loading"
          testId="gallery-stat-card-loading-group"
        >
          <StatCard
            label="Supporters"
            value=""
            loading
            change={{ percent: 0, direction: 'flat' }}
            testId="gallery-stat-card-loading-card"
          />
          <StatCard
            label="Notifications sent"
            value=""
            loading
            testId="gallery-stat-card-loading-no-change-card"
          />
        </StatCardRow>
      </State>

      <State
        title="Three across"
        note="Six cards then make two full rows, not four and two orphans."
      >
        <StatCardRow
          label="Sample summary, three across"
          columns={3}
          testId="gallery-stat-card-three-group"
        >
          <StatCard
            label="Delivered"
            value="1,204"
            testId="gallery-stat-card-three-1-card"
          />
          <StatCard label="Opened" value="611" testId="gallery-stat-card-three-2-card" />
          <StatCard label="Acted" value="88" testId="gallery-stat-card-three-3-card" />
          <StatCard label="Shared" value="42" testId="gallery-stat-card-three-4-card" />
          <StatCard label="Replied" value="17" testId="gallery-stat-card-three-5-card" />
          <StatCard
            label="Unsubscribed"
            value="3"
            testId="gallery-stat-card-three-6-card"
          />
        </StatCardRow>
      </State>
    </>
  );
}
